var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Agreementbox"},[_c('div',[_c('van-nav-bar',{attrs:{"title":"用户协议","left-text":"返回","left-arrow":""},on:{"click-left":_vm.onClickLeft}})],1),_c('Agreement')],1)}
var staticRenderFns = []

export { render, staticRenderFns }